import { OnboardingRegister, OnboardingRequest } from "@/@types/onboarding/shared";
import { IOperationRegister } from "@/@types/onboarding/operation";

export const isOperationRegister = (
  request: OnboardingRequest | OnboardingRegister,
): request is IOperationRegister => {
  return !!(request as IOperationRegister).operationId;
};
